import script from "./newUploadFIle.vue?vue&type=script&lang=ts&setup=true"
export * from "./newUploadFIle.vue?vue&type=script&lang=ts&setup=true"

import "./newUploadFIle.vue?vue&type=style&index=0&id=5c977d6a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c977d6a"]])

export default __exports__